export default __webpack_public_path__ + "static/projector_b.dd09ee1b453f8d819a4f2ceb490d88af.png";